import { Layers } from "lucide-react";

export default function AuthLoading() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-5">
        {/* Animated logo mark */}
        <div className="relative w-[72px] h-[72px]">
          {/* Outer spinning ring */}
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            className="absolute inset-0 animate-[spin_2.4s_cubic-bezier(0.4,0,0.2,1)_infinite]"
          >
            <circle
              cx="36"
              cy="36"
              r="32"
              fill="none"
              strokeWidth="2.5"
              strokeDasharray="140 60"
              strokeLinecap="round"
              className="stroke-primary"
            />
          </svg>
          {/* Inner spinning ring (reverse) */}
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            className="absolute inset-0 animate-[spin_1.8s_cubic-bezier(0.4,0,0.2,1)_infinite_reverse]"
          >
            <circle
              cx="36"
              cy="36"
              r="22"
              fill="none"
              strokeWidth="2"
              strokeDasharray="90 50"
              strokeLinecap="round"
              className="stroke-primary/40"
            />
          </svg>
          {/* Center icon */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Layers className="w-6 h-6 text-primary" />
          </div>
        </div>

        {/* Text */}
        <div className="flex flex-col items-center gap-1.5">
          <h2 className="text-xl font-bold tracking-tight text-foreground">
            Dynamatix
          </h2>
          <p className="text-xs font-normal tracking-widest uppercase text-muted-foreground">
            Loading your workspace
          </p>
        </div>

        {/* Animated progress bar */}
        <div className="w-40 h-[3px] rounded-full overflow-hidden bg-muted">
          <div className="h-full rounded-full bg-gradient-to-r from-primary via-primary/60 to-primary animate-[loader-progress_1.8s_cubic-bezier(0.4,0,0.2,1)_infinite]" />
        </div>
      </div>
    </div>
  );
}
